/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemProperty
 */
export interface SystemProperty {
    /**
     * 
     * @type {string}
     * @memberof SystemProperty
     */
    property?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemProperty
     */
    value?: string;
}

/**
 * Check if a given object implements the SystemProperty interface.
 */
export function instanceOfSystemProperty(value: object): value is SystemProperty {
    return true;
}

export function SystemPropertyFromJSON(json: any): SystemProperty {
    return SystemPropertyFromJSONTyped(json, false);
}

export function SystemPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemProperty {
    if (json == null) {
        return json;
    }
    return {
        
        'property': json['property'] == null ? undefined : json['property'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function SystemPropertyToJSON(value?: SystemProperty | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'property': value['property'],
        'value': value['value'],
    };
}

